export default __webpack_public_path__ + "static/media/arose.533b2621.svg";